import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetEntityTerminationTermCountUseCaseInterface } from 'domain/usecases';

export class RemoteGetEntityTerminationTermCount
  implements GetEntityTerminationTermCountUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetEntityTerminationTermCountUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetEntityTerminationTermCountUseCaseInterface.Params,
  ): Promise<GetEntityTerminationTermCountUseCaseInterface.Result> {
    const requestUrl = `${this.url}/${params.entityId}/report-terms-count`;
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
